import { Link } from "react-router-dom-v5-compat";

import { navAccent } from "../nav/navConstants";

type Props = {
  to: string;
  label: string;
  accentColor: string;
  isActive?: boolean;
  onClick?: () => void;
};

export const NavRecentDocRow: React.FC<Props> = ({ to, label, accentColor, isActive, onClick }) => (
  <Link
    to={to}
    onClick={onClick}
    title={label}
    css={{
      display: "flex",
      alignItems: "center",
      gap: "0.625rem",
      padding: "0.1875rem 0",
      textDecoration: "none",
      color: navAccent,
      "&:hover": { opacity: 0.85 },
    }}
  >
    <span
      css={{
        flexShrink: 0,
        width: "3px",
        alignSelf: "stretch",
        minHeight: "1rem",
        borderRadius: "2px",
        background: accentColor,
        opacity: isActive ? 1 : 0.55,
      }}
    />
    <span
      css={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "0.875rem",
        fontWeight: isActive ? 700 : 400,
      }}
    >
      {label}
    </span>
  </Link>
);
